export default {
  title: 'Nastavení',
  tabs: {
    general: 'Obecné',
    password: 'Heslo',
  },
};
